import { lazy } from "react";

const Onboarding = lazy(() => import("@/views/Onboarding"));
const TermsAndConditionsOrPrivacyPolicies = lazy(
  () => import("@/views/Onboarding/TermsAndConditionsOrPrivacyPolicies")
);

const OnboardingRoutes = [
  {
    path: "/login",
    component: <Onboarding />,
  },
  {
    path: "/terms-conditions",
    component: <TermsAndConditionsOrPrivacyPolicies />,
  },
  {
    path: "/privacy-policies",
    component: <TermsAndConditionsOrPrivacyPolicies />,
  },
];

export default OnboardingRoutes;
